'use client';

import type {ReactNode} from 'react';
import {I18nProvider, type CompactTranslations} from '@udemy-v2/i18n';

import {ENGLISH_LANG, ENGLISH_LOCALE} from './constants';

// `I18nProvider` calls `React.createContext` but its own module has no "use client"
// directive — it only works inside an existing client boundary. This wrapper provides
// that boundary so the (server) communities layout can render it.
export function EnglishI18nProvider({
    translations,
    children,
}: {
    translations: CompactTranslations;
    children: ReactNode;
}) {
    return (
        <I18nProvider lang={ENGLISH_LANG} locale={ENGLISH_LOCALE} translations={translations}>
            {children}
        </I18nProvider>
    );
}
